/**
 * Impersonation feature gate.
 * Disabled: impersonation UI is hidden and stored impersonation state is ignored.
 * (Re-enable by returning env check: raw === 'true' || raw === '1')
 */

export const isImpersonationEnabled = (): boolean => false;
